module.exports = __webpack_public_path__ + "static/media/excel.08abc6ac.svg";